/**
 * What a teacher sees when the teaching query fails.
 *
 * It exists so that a failed request never reads as an empty one. "You aren't
 * assigned to any classes" is alarming and wrong when the truth is that the
 * page could not ask, and a teacher has no way to tell the two apart.
 */
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '~/components/ui/card';
import { Button } from '~/components/ui/button';

export default function TeachingLoadError({ error }: { error: Error }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Couldn't load your teaching</CardTitle>
        <CardDescription>
          Your classes are still there — this page couldn't reach them. Reload to try again, and if it keeps
          happening, send this to an admin: {error.message}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Button variant="outline" size="sm" onClick={() => window.location.reload()}>
          Reload
        </Button>
      </CardContent>
    </Card>
  );
}
